
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new/[pageNumber]",
      function () {
        return require("private-next-pages/new/[pageNumber]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new/[pageNumber]"])
      });
    }
  